(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["shared/polyfills"] = factory();
	else
		root["@averoachmea/static"] = root["@averoachmea/static"] || {}, root["@averoachmea/static"]["shared/polyfills"] = factory();
})(window, function() {
return 